import { Decoration_Type } from "./../../ricos-types/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getAnchorData = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === "text";
    });
    if (node?.marks.some((mark) => mark.type.name === Decoration_Type.ANCHOR)) {
      return node.marks[0].attrs.anchor;
    }
  }
  return false;
});
export {
  getAnchorData
};
//# sourceMappingURL=get-anchor-data.js.map
